import React from 'react';
import { useDecision } from '@optimizely/react-sdk';
import { OPTIMIZELY_FLAGS } from 'config/optimizely';
import universal from 'react-universal-component';
import { LoadingPage } from 'components/core/LoadingPage';

const options = {
	loading: LoadingPage,
	timeout: 60000,
};

// Code split V1 and V2 directly (not through Bundles.js to avoid circular dependency)
// Users only download the variant they see
const FacilityPage = universal(
	import(/* webpackChunkName: "FacilityPage" */ './FacilityPage'),
	options,
);
const FacilityPageV2 = universal(
	import(
		/* webpackChunkName: "FacilityPageV2" */ '../FacilityPageV2/FacilityPageV2'
	),
	options,
);

/**
 * FacilityPageWrapper - A/B Test Controller
 *
 * This component acts as a router between FacilityPage (legacy) and FacilityPageV2 (redesign).
 * It uses Optimizely feature flags to determine which version to render.
 *
 * Decision logic:
 * - If OPTIMIZELY_FLAGS.FACILITY_PAGE_TESTING is enabled → Show FacilityPageV2 (redesign)
 * - If disabled or flag doesn't exist → Show FacilityPage (legacy)
 *
 * This architecture provides:
 * - Clean separation of concerns
 * - No CSS conflicts between versions
 * - Single decision point for A/B testing
 * - Easy rollback/rollforward capabilities
 * - Code-splitting: users only download the variant they see
 */
export default function FacilityPageWrapper(props) {
	const [decision] = useDecision(OPTIMIZELY_FLAGS.FACILITY_PAGE_TESTING);
	if (decision?.enabled) {
		return <FacilityPageV2 {...props} />;
	}
	return <FacilityPage {...props} />;
}
